import { getRuleFiltersConfigBySection } from '@kw/quokka-ui';
import { FiltersAndTable } from '../FiltersAndTable';
import { OrgPolicyResults } from '../types/ApplicationDetailsType';

interface IProps {
  ruleSummaries: object;
  analysisId: string;
  policyViolations?: OrgPolicyResults[];
}

export const Permissions = ({ ruleSummaries, analysisId, policyViolations }: IProps) => {
  return <FiltersAndTable analysisId={analysisId} data={ruleSummaries} filterSection="permission" policyViolations={policyViolations}/>;
};
